<template>
    <div>
        <v-dialog v-model="showForm" scrollable max-width="400">
            <v-card>
                <v-toolbar card prominent color="primary" dark>
                    <v-toolbar-title class="body-2">Cambiar contraseña</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon @click="cancelForm()">
                        <v-icon>close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text>
                    <v-form ref="passwordForm" v-model="validPasswordChange">
                        <v-container fluid grid-list-xl>
                            <v-layout align-center wrap>
                                <v-flex xs12>
                                    <v-text-field
                                        v-model="passwordItem.old_password"
                                        label="Contraseña actual"
                                        :append-icon="showOldPassword ? 'visibility' : 'visibility_off'"
                                        :type="showOldPassword ? 'text' : 'password'"
                                        @click:append="showOldPassword = !showOldPassword"
                                        @keydown="old_passwordErrors = passwordErrors = password_repeatErrors = []"
                                        :rules="old_passwordRules"
                                        :error-messages="old_passwordErrors"
                                    >
                                    </v-text-field>
                                </v-flex>

                                <v-flex xs12>
                                    <v-text-field
                                        v-model="passwordItem.password"
                                        label="Contraseña nueva"
                                        :append-icon="showPassword ? 'visibility' : 'visibility_off'"
                                        :type="showPassword ? 'text' : 'password'"
                                        @click:append="showPassword = !showPassword"
                                        @keydown="old_passwordErrors = passwordErrors = password_repeatErrors = []"
                                        :rules="passwordRules"
                                        :error-messages="passwordErrors"
                                    >
                                    </v-text-field>
                                </v-flex>

                                <v-flex xs12>
                                    <v-text-field
                                        v-model="passwordItem.password_repeat"
                                        label="Confirmar contraseña"
                                        :append-icon="showRepeatPassword ? 'visibility' : 'visibility_off'"
                                        :type="showRepeatPassword ? 'text' : 'password'"
                                        @click:append="showRepeatPassword = !showRepeatPassword"
                                        @keydown="old_passwordErrors = passwordErrors = password_repeatErrors = []"
                                        :rules="[password_repeatRule, passwordConfirmationRule]"
                                        :error-messages="password_repeatErrors"
                                    >
                                    </v-text-field>
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="red" flat @click="cancelForm()" :disabled="loading">Cancelar</v-btn>
                    <v-btn color="success" flat @click="saveForm()" :disabled="disableSaveButton" :loading="loading"
                        >Guardar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
export default {
    name: "PasswordChange",
    data() {
        return {
            loading: false,
            showOldPassword: false,
            showPassword: false,
            showRepeatPassword: false,

            validPasswordChange: false,
            passwordItem: {
                old_password: "",
                password: "",
                password_repeat: ""
            },
            old_passwordRules: [
                v => !!v || "Debe proporcionar la contraseña actual.",
                v => v.length >= 6 || "La contraseña debe tener al menos 6 caracteres."
            ],
            old_passwordErrors: [],
            passwordRules: [
                v => !!v || "Debe proporcionar la contraseña nueva.",
                v => v.length >= 6 || "La contraseña debe tener al menos 6 caracteres."
            ],
            passwordErrors: [],
            password_repeatRule: v => !!v || "Debe confirmar la contraseña nueva.",
            password_repeatErrors: [],

            cancelForm() {
                this.$emit("passwordChangeCanceled")
            }
        }
    },

    computed: {
        showForm: {
            get: function() {
                return !this.$vuetify.breakpoint.smAndDown
            },
            set: function() {
                return this.cancelForm()
            }
        },

        disableSaveButton() {
            return this.loading || !this.validPasswordChange
        },

        passwordConfirmationRule() {
            if (this.passwordItem.password !== "" && this.passwordItem.password_repeat !== "") {
                return (
                    this.passwordItem.password === this.passwordItem.password_repeat ||
                    "La contraseña proporcionada no coincide con la anterior"
                )
            } else return true
        }
    },

    methods: {
        saveForm() {
            this.loading = true
            this.$refs.passwordForm.validate()
            if (this.validPasswordChange) {
                this.$store.dispatch("UPDATE_AUTH_PASSWORD", this.passwordItem).then(result => {
                    if (result === null || result.status === 404 || result.status === 500 || !result) {
                        //cerrar el formulario si se inserto o actualizo bien (null) o cuando el elemento no existe o no hay coneccion con el servidor
                        this.$emit("passwordChangeCanceled")
                    } else {
                        // El backend devolvió error de validación, pasando los errores a los campos correspondientes
                        let { data, status } = result
                        if (status === 422) {
                            data.forEach(error => {
                                switch (error.field) {
                                    case "old_password":
                                        this.old_passwordErrors.push(error.message)
                                        break
                                    case "password":
                                        this.passwordErrors.push(error.message)
                                        break
                                    case "password_repeat":
                                        this.password_repeatErrors.push(error.message)
                                        break
                                }
                            })
                        }
                    }
                    this.loading = false
                })
            } else {
                this.loading = false
            }
        }
    }
}
</script>

<style scoped></style>
